(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aqk-header"]) return;
  try {
    
  (() => {
    const initializeHeader = () => {
      if (window.kneovaHeaderInitialized) return;
      window.kneovaHeaderInitialized = true;

      const renderCartCount = (value) => {
        const count = Math.max(0, Number.parseInt(value, 10) || 0);

        document.querySelectorAll('[data-aqk-cart-link]').forEach((link) => {
          const countElement = link.querySelector('[data-aqk-cart-count]');
          const cartLabel = link.dataset.cartLabel || 'Cart';
          const itemLabel = count === 1 ? 'item' : 'items';

          if (countElement) countElement.textContent = count;
          link.setAttribute('aria-label', `${cartLabel}, ${count} ${itemLabel}`);
        });
      };

      const refreshCartCount = () => {
        const cartRoute = window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
        const cartJsonRoute = cartRoute.endsWith('.js') ? cartRoute : `${cartRoute}.js`;

        return fetch(cartJsonRoute, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);
            return response.json();
          })
          .then((cart) => renderCartCount(cart.item_count))
          .catch(() => undefined);
      };

      const handleCartUpdate = (event = {}) => {
        const count = event.cartData?.item_count ?? event.detail?.cartData?.item_count ?? event.detail?.item_count;

        if (Number.isFinite(Number(count))) {
          renderCartCount(count);
        } else {
          refreshCartCount();
        }
      };

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
      }

      document.addEventListener('cartUpdated', handleCartUpdate);
      document.addEventListener('shopify:section:load', refreshCartCount);
      window.addEventListener('pageshow', refreshCartCount);

      document.querySelectorAll('.aqk-menu').forEach((menu) => {
        const summary = menu.querySelector('summary');
        const syncMenuLabel = () => summary?.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');

        menu.addEventListener('toggle', syncMenuLabel);
        menu.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !menu.open) return;

          event.preventDefault();
          menu.open = false;
          summary?.focus();
        });
        syncMenuLabel();
      });

      document.addEventListener('change', (event) => {
        const select = event.target.closest('[data-aqk-country-select]');
        if (select) select.form?.requestSubmit();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeHeader, { once: true });
    } else {
      initializeHeader();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqk-real-product-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kneova-proof-media')) {
    customElements.define(
      'kneova-proof-media',
      class extends HTMLElement {
        connectedCallback() {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.querySelectorAll('[data-kneova-proof-video]').forEach((video) => {
            if (reducedMotion) {
              video.removeAttribute('autoplay');
              video.pause();
              return;
            }

            video.play().catch(() => {});
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
